<template>
  <div class="chainEncrypt-wrapper">
    <el-form
      ref="formDate"
      :model="formDate"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-ruleForm"
      :rules="editRules"
      label-position="left"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="加密方式" prop="method">
            <el-select
              v-model="formDate.method"
              placeholder="请选择"
              class="auto-width"
              @change="methodChange"
            >
              <el-option
                v-for="ele in options"
                :key="parseInt(ele.value)"
                :label="ele.label"
                :value="parseInt(ele.value)"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="公钥" prop="pub_key">
            <el-input v-model="formDate.pub_key" placeholder="请输入共钥"></el-input>
          </el-form-item> </el-col
        ><el-col :span="12">
          <el-form-item label="余额1" prop="text1">
            <el-input v-model="formDate.text1" placeholder="请输入密文"></el-input>
          </el-form-item> </el-col
        ><el-col :span="12">
          <el-form-item
            v-if="formDate.method == 1 || formDate.method == 3"
            label="余额2"
            prop="text2"
          >
            <el-input v-model="formDate.text2" placeholder="请输入密文"></el-input>
          </el-form-item> </el-col
        ><el-col :span="12">
          <el-form-item
            v-if="formDate.method == 2 || formDate.method == 4 || formDate.method == 5"
            label="明文"
            prop="text2"
          >
            <el-input v-model="formDate.text2" placeholder="请输入明文"></el-input>
          </el-form-item> </el-col
        ><el-col :span="12">
          <!-- <el-form-item label="解密文本">
        <el-input v-model="proclaimedTextEncryption" class="excellent-form-input readonly-text"
          readonly="" type="textarea" autosize="" disabled></el-input>
        <el-button v-if="isChangeText" class="excellent-form-btn" @click.prevent="changeText()">隐藏</el-button>
        <el-button v-if="!isChangeText" class="excellent-form-btn" @click.prevent="changeText()">显示</el-button>
      </el-form-item> --> </el-col
        ><el-col :span="24">
          <el-form-item>
            <el-button type="primary" @click="handleCompute()">确定</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'Index',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 100
  },
  data() {
    return {
      formDate: {
        method: '',
        pub_key: '',
        chain_id: '',
        user_id: String(JSON.parse(localStorage.getItem('cbaas_system_userInfo')).ID),
        text1: '',
        text2: ''
      },
      editRules: {
        method: [{ required: true, message: '请输入选择加密方式', trigger: 'blur' }],
        pub_key: [{ required: true, message: '请输入公钥', trigger: 'blur' }],
        text1: [{ required: true, message: '请输入', trigger: 'blur' }],
        text2: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      options: [
        {
          label: '两个密文相加',
          value: 1
        },
        {
          label: '密文加明文',
          value: 2
        },
        {
          label: '密文减密文',
          value: 3
        },
        {
          label: '密文减明文',
          value: 4
        },
        {
          label: '密文乘以明文',
          value: 5
        }
      ],
      isChangeText: false,
      proclaimedTextDecryption: '', //显示文本
      proclaimedText: '', //后台返回后文本
      proclaimedTextEncryption: '', //加密
      adaptationVars: {
        formLabelWidth: 100
      }
    }
  },
  watch: {
    '$store.state.computing.chainId': {
      deep: true,
      handler(val) {
        this.formDate.chain_id = val
      }
    }
  },
  mounted() {
    this.formDate.chain_id = this.$store.state.computing.chainId
    this.formDate.method = parseInt(localStorage.getItem('method')) || null // 设置初始值
  },
  methods: {
    handleCompute() {
      this.$refs.formDate.validate().then(valid => {
        if (valid) {
          this.$apis.encryption.compute(this.formDate).then(res => {
            if (res) {
              this.$message.success('加密成功!')
            }
          })
        }
      })
    },
    changeText() {
      this.isChangeText = !this.isChangeText

      this.isChangeText
        ? (this.proclaimedTextEncryption = this.proclaimedText)
        : (this.proclaimedTextEncryption = '********')
    },
    methodChange(val) {
      localStorage.setItem('method', val)
    }
  }
}
</script>

<style scoped lang="scss">
.chainEncrypt-wrapper {
  .el-row {
    margin: 0 calc(0px - var(--base-size-16));

    .el-col {
      padding: 0 var(--base-size-16);
    }
  }
}
</style>
